import axios from "axios";

import Config from "../../config";

const getActionListaUsuariosByClienteId = (clienteId, showAll) => {
    
    return axios({
        method: "get",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v1/usuarios/lista/byClienteId/${clienteId}${showAll ? `?show_all=${showAll}` : ''}`,
    });
};

export default getActionListaUsuariosByClienteId;
